import * as ambassadorWixPromoteSeoV2LlmsTxt from './promote-seo-v2-llms-txt-llms-txt.http.js';
import * as ambassadorWixPromoteSeoV2LlmsTxtTypes from './promote-seo-v2-llms-txt-llms-txt.types.js';
import * as ambassadorWixPromoteSeoV2LlmsTxtUniversalTypes from './promote-seo-v2-llms-txt-llms-txt.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getLlmsTxt(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPromoteSeoV2LlmsTxtUniversalTypes.GetLlmsTxtRequest,
  ambassadorWixPromoteSeoV2LlmsTxtTypes.GetLlmsTxtRequest,
  ambassadorWixPromoteSeoV2LlmsTxtUniversalTypes.GetLlmsTxtResponse,
  ambassadorWixPromoteSeoV2LlmsTxtTypes.GetLlmsTxtResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPromoteSeoV2LlmsTxt.getLlmsTxt(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/llms',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateLlmsTxt(): __PublicMethodMetaInfo<
  'PUT',
  {},
  ambassadorWixPromoteSeoV2LlmsTxtUniversalTypes.UpdateLlmsTxtRequest,
  ambassadorWixPromoteSeoV2LlmsTxtTypes.UpdateLlmsTxtRequest,
  ambassadorWixPromoteSeoV2LlmsTxtUniversalTypes.UpdateLlmsTxtResponse,
  ambassadorWixPromoteSeoV2LlmsTxtTypes.UpdateLlmsTxtResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPromoteSeoV2LlmsTxt.updateLlmsTxt(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v2/llms',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function appendLlmsTxt(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixPromoteSeoV2LlmsTxtUniversalTypes.AppendLlmsTxtRequest,
  ambassadorWixPromoteSeoV2LlmsTxtTypes.AppendLlmsTxtRequest,
  ambassadorWixPromoteSeoV2LlmsTxtUniversalTypes.AppendLlmsTxtResponse,
  ambassadorWixPromoteSeoV2LlmsTxtTypes.AppendLlmsTxtResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPromoteSeoV2LlmsTxt.appendLlmsTxt(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/llms',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateLlmsTxtHiddenStatus(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixPromoteSeoV2LlmsTxtUniversalTypes.UpdateLlmsTxtHiddenStatusRequest,
  ambassadorWixPromoteSeoV2LlmsTxtTypes.UpdateLlmsTxtHiddenStatusRequest,
  ambassadorWixPromoteSeoV2LlmsTxtUniversalTypes.UpdateLlmsTxtHiddenStatusResponse,
  ambassadorWixPromoteSeoV2LlmsTxtTypes.UpdateLlmsTxtHiddenStatusResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPromoteSeoV2LlmsTxt.updateLlmsTxtHiddenStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/llms/hidden',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  LlmsTxt as LlmsTxtOriginal,
  GetLlmsTxtRequest as GetLlmsTxtRequestOriginal,
  GetLlmsTxtResponse as GetLlmsTxtResponseOriginal,
  UpdateLlmsTxtRequest as UpdateLlmsTxtRequestOriginal,
  UpdateLlmsTxtResponse as UpdateLlmsTxtResponseOriginal,
  AppendLlmsTxtRequest as AppendLlmsTxtRequestOriginal,
  AppendLlmsTxtResponse as AppendLlmsTxtResponseOriginal,
  UpdateLlmsTxtHiddenStatusRequest as UpdateLlmsTxtHiddenStatusRequestOriginal,
  UpdateLlmsTxtHiddenStatusResponse as UpdateLlmsTxtHiddenStatusResponseOriginal,
  UpdateLlmsTxtManuallyEditedStatusRequest as UpdateLlmsTxtManuallyEditedStatusRequestOriginal,
  UpdateLlmsTxtManuallyEditedStatusResponse as UpdateLlmsTxtManuallyEditedStatusResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './promote-seo-v2-llms-txt-llms-txt.types.js';
